(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lmn-signage-gallery"] && !Shopify.designMode) return;
  try {
    function initializeSignageGallery() {
  const gallery = document.querySelector('[data-signage-gallery]');
  if (!gallery || gallery.dataset.initialized) return;
  gallery.dataset.initialized = 'true';
  const selector = document.querySelector('.main-product__variant-selector variant-selects[data-section="main-product"]');
  if (!selector) return;
  const variants = JSON.parse(selector.querySelector('script[type="application/json"]').textContent);
  const photos = JSON.parse(gallery.querySelector('[data-signage-images]').textContent);
  const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
  const swatches = {White:'#f1f1eb', Blue:'#5799ed', Green:'#5dde77', Red:'#ed6759', WarmWhite:'#f2d986', RGB:'conic-gradient(#ed6759,#5dde77,#5799ed,#ed6759)'};
  const sizeField = selector.querySelector('fieldset[data-option-position="1"]');
  const colorField = selector.querySelector('fieldset[data-option-position="2"]');
  const sizeDialog = gallery.querySelector('[data-size-dialog]');
  const openGuide = () => sizeDialog.showModal();
  const readOptions = () => Array.from(selector.querySelectorAll('fieldset')).map(field => field.querySelector('input:checked')?.value);
  const view = name => {
    gallery.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== name; });
    gallery.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === name)));
  };
  const setPhoto = color => {
    if (!photos[color]) return;
    gallery.querySelectorAll('.lmn-closeup,.lmn-closeup-thumb,.lmn-closeup-zoom').forEach(img => {img.removeAttribute('srcset'); img.src=photos[color];});
  };
  const update = (changed = false) => {
    const [size,color] = readOptions();
    const variant = variants.find(v => v.option1===size && v.option2===color);
    gallery.querySelector('[data-current-size]').textContent=size;
    const dimensions = size?.match(/\((\d+)\s*x\s*(\d+)/);
    if (dimensions) {
      const shape = gallery.querySelector('[data-current-shape]');
      shape.style.width=`${Number(dimensions[1])*5}px`;
      shape.style.height=`${Number(dimensions[2])*5}px`;
    }
    gallery.querySelectorAll('[data-guide-size]').forEach(cell => {cell.dataset.selected=String(cell.dataset.guideSize===size);});
    colorField.querySelectorAll('input').forEach(input => {
      input.disabled=!variants.some(v=>v.option1===size && v.option2===input.value && v.available);
    });
    if (changed && variant) {
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      if (previewTheme) url.searchParams.set('preview_theme_id',previewTheme);
      history.replaceState(history.state,'',url);
    }
    setPhoto(color);
  };
  sizeField.querySelectorAll('label').forEach(label => {
    const input=label.querySelector('input');
    if(!input)return;
    const match=input.value.match(/^(.*?)\s*\((.*?)\)$/);
    if(!match)return;
    [...label.childNodes].forEach(node=>{if(node.nodeType===Node.TEXT_NODE)node.remove();});
    const name=document.createElement('span');name.textContent=match[1];
    const size=document.createElement('small');size.textContent=match[2].replace(' x ',' × ');
    label.append(name,size);
  });
  colorField.querySelectorAll('label').forEach(label=>{
    const input=label.querySelector('input');
    if(!input)return;
    label.style.setProperty('--lmn-swatch',swatches[input.value]||'#ddd');
    if(input.value==='WarmWhite') {
      [...label.childNodes].forEach(node=>{if(node.nodeType===Node.TEXT_NODE)node.remove();});
      const name=document.createElement('span');name.textContent=gallery.dataset.warmWhite;label.append(name);
    }
  });
  const sizeLegend=sizeField.parentElement.querySelector('legend');
  sizeLegend.textContent=gallery.dataset.chooseSize;
  const compare=document.createElement('button');compare.type='button';compare.className='lmn-text-button';compare.textContent=gallery.dataset.compareSizes;compare.addEventListener('click',openGuide);sizeLegend.append(compare);
  colorField.parentElement.querySelector('legend').textContent=gallery.dataset.chooseLight;
  const helper=document.createElement('p');helper.className='lmn-color-help';helper.textContent=gallery.dataset.colorHelp;
  if(!variants.some(v=>v.option2==='RGB'&&v.available))helper.textContent+=' '+gallery.dataset.rgbUnavailable;
  colorField.after(helper);
  const price=document.querySelector('.main-product__price');
  if(price){const shipping=document.createElement('span');shipping.className='lmn-shipping';shipping.textContent=gallery.dataset.freeShipping;price.append(shipping);}
  gallery.querySelectorAll('[data-view]').forEach(button=>button.addEventListener('click',()=>view(button.dataset.view)));
  gallery.querySelectorAll('[data-open-sizes]').forEach(button=>button.addEventListener('click',openGuide));
  gallery.querySelector('[data-zoom]').addEventListener('click',()=>gallery.querySelector('[data-photo-dialog]').showModal());
  gallery.querySelectorAll('dialog').forEach(dialog=>{
    dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  });
  selector.addEventListener('change',event=>{queueMicrotask(()=>{update(true);if(event.target.closest('fieldset')===colorField)view('product');});});
  update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeSignageGallery);else initializeSignageGallery();
document.addEventListener('shopify:section:load',initializeSignageGallery);
  } catch(e) { console.error(e); }
})();

})();
